import React from 'react';
import PropTypes from 'prop-types';
// import HomeScreen from './HomeScreen';
// import TicketTypeSelectorScreen from './TicketTypeSelectorScreen';
import IssueScreen from './IssueScreen';
// import AccessibilityIssueScreen from './AccessibilityIssueScreen';

const Screens = React.memo(({ routeStack, gotoScreen, handleClose }) => {
  const currentScreen = routeStack.slice(-1)[0];
  const props = {
    gotoScreen,
    screenType: currentScreen,
    closeWidget: handleClose,
  };

  return <IssueScreen {...props} />;

  // switch (currentScreen) {
  //   case 'home':
  //     return <HomeScreen {...props} />;
  //   case 'ticketTypeSelector':
  //     return <TicketTypeSelectorScreen {...props} />;
  //   case 'supportTicket':
  //   case 'featureIdea':
  //     return <IssueScreen {...props} />;
  //   case 'accessibilityIssue':
  //     return <AccessibilityIssueScreen {...props} />;
  //   default:
  //     return null;
  // }
});

Screens.propTypes = {
  routeStack: PropTypes.arrayOf(PropTypes.string).isRequired,
  gotoScreen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default Screens;



// WEBPACK FOOTER //
// ./src/client/Components/SupportWidget/Screens/index.js